module.exports = __webpack_public_path__ + "img/osirase.3a426725.png";